//
// LocationFeature.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "@sas-dvr/ltjs-commons/maps/MapSearchResult";
import "@sas-dvr/ltjs-commons/maps/MapSearchHint";

var LocationFeature = createModule("gtl_LocationFeature", [20267], EventDispatcher, [
    ,
    ,
    ,
    {
        country: 7,
        address: 7,
        color: 10,
        latLon: 11,
        name: 7,
        description: 7,
        pixelLocation: 11,
    },
    {
        setVisible: [0,2],
        select: [0,2],
        getLinks: [[1]],
        getSearchHints: [[1]],
        link: [0,1],
        requestSearchHints: [0,7,4],
        setAddressFromReverseGeocode: [0],
        isVisible: [2],
        clearSearch: [0],
        search: [0,7,7,11,4],
        unlink: [0,1],
        isSelected: [2],
        getSearchResults: [[1]],
        unlinkAll: [0],
    },
    ,
    ,
]);
export default LocationFeature;
